export const STOCK_CONFIG = {
    requests: {
        getReserves: {
            url: `stock/reserves`,
        },
        getNonCenterReserves: {
            url: `stock/non-center/reserves`,
        },
        getReservesByRefNo: {
            url: `stock/reserves/ref-no`,
        },
        getReservesCenter: {
            url: `stock/center/reserves`,
        },
        getReceives: {
            url: `stock/receives`,
        },
        getTransfers: {
            url: `stock/transfers`,
        },
        getAdjusts: {
            url: `stock/adjusts`, 
        },
        getLotsBranch: {
            url: `stock/branchs`,
        },
        getAllBranchLot: {
            url: `stock/lots`,
        },
        getAllLot: {
            url: `stock/items`,
        },
        getZonesBranch: {
            url: `dbms/branchs`, 
        },
        importReserves: {
            url: `stock/import/reserves`, 
        },
        getLastLot: {
            url: `stock/latestLot`, 
        },
        getNotify: {
            url: `notify`, 
        },
        getAllLotHq: {
            url: `stock/all-lots`, 
        },
    },
};
